import React, { useEffect, useState } from "react";
import Sidebar from "../components/Sidebar"
import Header from "../components/Header";
import { useNavigate } from "react-router-dom";
import Footer from "../components/Footer"

const Layout = ({ children }) => {
  const navigate = useNavigate();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);


  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token || token === "") {
      navigate("/login");
    }
  }, []);
  const toggleSidebar = () => {
    setIsSidebarOpen((prevState) => !prevState);
  };


  return (
    <div className={`site-content-wrapper ${isSidebarOpen ? "sidebar_close" : ""}`}>
      <Header toggleSidebar={toggleSidebar} />
      <div className="dashboard">
        <Sidebar isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
        <div className="main-content">
          {children}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Layout;


